// extracted by mini-css-extract-plugin
export default {"LoginPageContainer":"LoginPage_LoginPageContainer__HtFvO","InfoSectionsContainer":"LoginPage_InfoSectionsContainer__wsO+c"};